




import Home from '@/components/userAuthViewComponents/Home.vue';
import Vue from 'vue'
import { Component } from 'vue-property-decorator'


@Component({
  name: 'UserAuthView',
  components: {
    Home
  }
})
export default class UserAuthView extends Vue {

}
